import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { StringUtils } from "Global/Base/Utils/StringUtils";
import { registerCustomElement } from "./Utils/CustomElementUtils";

const logger = LazyLoadingSectionLogger.create(LoggingSection.unsupportedComponent);

/**
 * @internal
 */
export class UnsupportedComponent extends HTMLElement {
    protected static get observedAttributes(): string[] {
        return ["data-unsupported-type"];
    }

    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        this.classList.add("unsupported-component");
        this.innerHTML = "Unsupported";
    }

    protected attributeChangedCallback(attr: string, _oldVal: string, newVal: string): void {
        if (attr !== "data-unsupported-type") // už zbytečné, ale pro jistotu
            return;

        const message = `Komponenta '${StringUtils.stringToHTMLText(newVal)}' není v tuto chvíli podporovaná. Funkčnost formuláře proto nemůže být zaručena.`;

        this.innerHTML += `<div class="extendedMessage">${message}</div>`;
        this.title = message;

        logger.warn(message);
    }
}

registerCustomElement("tsc-base-unsupported-component", UnsupportedComponent);
